module.exports = __webpack_public_path__ + "static/media/icon_calendar_nav_left.e9ebea68.svg";